/**
 * Frontend Event Tracking Utility
 *
 * Fire-and-forget: never blocks UI, never throws.
 * Events are sent to POST /api/events with JWT auth.
 *
 * Usage:
 *   import { trackEvent } from '../shared/utils/eventTracking';
 *   trackEvent('compare_add_player', { playerId: '123', metadata: { context: 'available_players' } });
 *
 * Allowed frontend event types (backend will reject others):
 *   - compare_add_player
 *   - compare_remove_player
 *   - save_search_created
 *   - recommendations_shown
 *   - recommendation_clicked
 */

import url from '../../constants/config';

const trackEvent = (type, { playerId, metadata } = {}) => {
  try {
    const token = window.localStorage.getItem('authorization');
    if (!token) return;

    const body = { type };
    if (playerId) body.playerId = playerId;
    if (metadata) body.metadata = metadata;

    fetch(`${url}/events`, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        Authorization: `Bearer ${token}`,
      },
      body: JSON.stringify(body),
    }).catch(() => {
      // Silent fail — fire and forget
    });
  } catch (e) {
    // Never throw — tracking must not break the app
  }
};

export default trackEvent;
